import React, {forwardRef} from 'react';

const FocusWrappedLabel = forwardRef((props, ref) => <label ref={ref} {...props}></label>);

FocusWrappedLabel.defaultProps = {
	__WRAPPED_LABEL: true
};

export default FocusWrappedLabel;
